import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { updateUiAction } from 'actions/uiActions'
import { changeCameraAction, destroyCameraAction } from 'actions/cameraActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Panel from 'components/Panel'
import GeneralPanelContainer from 'components/GeneralPanelContainer'
import FovPreview from 'components/FovPreview'
import PpfPreview from 'components/PpfPreview'
import AdvancedPanelContainer from 'components/AdvancedPanelContainer'
import BlindSpotPanelContainer from 'components/BlindSpotPanelContainer'
import DeviceDescription from 'components/DeviceDescription'
import WiringPanel from 'components/WiringPanel'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import { messageAction } from 'actions/messageActions'
import { destroyMultiImagerAction } from 'actions/multiImagerActions'

const mapStateToProps = ({ ui: { simulatedViewPanelOpen, simulatedPersonPanelOpen, cameraDescriptionPanelOpen,
    advancedPanelOpen, blindSpotPanelOpen, wiringPanelOpen }, cameras }) => {
  const currentCamera = getCurrentCamera(cameras)
  return {
    simulatedViewPanelOpen,
    simulatedPersonPanelOpen,
    cameraDescriptionPanelOpen,
    advancedPanelOpen,
    blindSpotPanelOpen,
    wiringPanelOpen,
    currentCamera,
    multiImager: cameras.find(c => c.id === currentCamera.imagerId)
  }
}

class CameraDetails extends React.Component {
  deleteHandler = _ => {
    const { currentCamera: { id, locked, name, isMultiImager, imagerId }, multiImager, messageAction, destroyCameraAction, destroyMultiImagerAction } = this.props

    if ((imagerId && multiImager.locked) || (!imagerId && locked)) {
      messageAction('generalError', 'Cannot delete locked camera. Right click to unlock.')
    } else if (imagerId) {
      if (window.confirm(`Are you sure you want to delete ${multiImager.name} and all imagers?`)) destroyMultiImagerAction(imagerId)
    } else {
      if (window.confirm(`Are you sure you want to delete ${name + (isMultiImager ? ' and all imagers' : '')}?`)) {
        isMultiImager ? destroyMultiImagerAction(id) : destroyCameraAction(id)
      }
    }
  }

  render() {
    const { simulatedViewPanelOpen, simulatedPersonPanelOpen, cameraDescriptionPanelOpen, advancedPanelOpen, blindSpotPanelOpen,
      wiringPanelOpen, currentCamera, updateUiAction, changeCameraAction, classes } = this.props
    const { id, locked, imagerId, isMultiImager } = currentCamera

    return (
      <div className={classes.cameraDetails}>
        <div className={classes.topUiControls}>
          <a onClick={_ => imagerId ? changeCameraAction(imagerId) : updateUiAction({ sidebarView: 'cameraList' })}>
            <FontAwesomeIcon icon='caret-left' className={classes.goBackButton} />
            { imagerId ? 'Multi-Imager' : 'All Project Items' }
          </a>
          <a
            onClick={this.deleteHandler}
            className={classes.destroyCameraButton}
            title='Delete Camera'
          >
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </a>
        </div>
        <GeneralPanelContainer />
        { !isMultiImager &&
          <div>
            <Panel
              active={simulatedViewPanelOpen}
              component={<FovPreview />}
              title='Simulated View'
              updateUiAction={updateUiAction}
              uiKey='simulatedViewPanelOpen'
            />
            <Panel
              active={simulatedPersonPanelOpen}
              component={<PpfPreview />}
              title='Simulated Person'
              updateUiAction={updateUiAction}
              uiKey='simulatedPersonPanelOpen'
            />
            { !imagerId &&
              <Panel
                active={wiringPanelOpen}
                component={<WiringPanel startDevice={currentCamera} startDeviceType='camera' />}
                title='Cabling to Network Closet'
                updateUiAction={updateUiAction}
                uiKey='wiringPanelOpen'
              />
            }
            <Panel
              active={blindSpotPanelOpen}
              component={<BlindSpotPanelContainer />}
              title='Blind Spot'
              updateUiAction={updateUiAction}
              uiKey='blindSpotPanelOpen'
            />
            <Panel
              active={advancedPanelOpen}
              component={<AdvancedPanelContainer />}
              title='Advanced: Lens, IR'
              updateUiAction={updateUiAction}
              uiKey='advancedPanelOpen'
            />
          </div>
        }
        { isMultiImager &&
          <Panel
            active={wiringPanelOpen}
            component={<WiringPanel startDevice={currentCamera} startDeviceType='camera' />}
            title='Cabling to Network Closet'
            updateUiAction={updateUiAction}
            uiKey='wiringPanelOpen'
          />
        }
        <Panel
          active={cameraDescriptionPanelOpen}
          component={<DeviceDescription currentDevice={currentCamera} type='camera' skipLocation={imagerId || isMultiImager} />}
          title={imagerId || isMultiImager ? 'Description, Notes' : 'Location, Description, Notes'}
          updateUiAction={updateUiAction}
          uiKey='cameraDescriptionPanelOpen'
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateUiAction, destroyCameraAction, changeCameraAction,
  messageAction, destroyMultiImagerAction })(injectSheet(style)(CameraDetails))



// WEBPACK FOOTER //
// ./src/components/CameraDetails/index.js